import React from "react";
import { ActivityDuplicateFormStyled } from "./styled";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Buttons, Inputs } from "components";

const ActivityDuplicateForm = ({ options, onCancel, onSubmit }) => {
  const schema = yup.object().shape({
    activity: yup.object().nullable().required("Required"),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  return (
    <ActivityDuplicateFormStyled>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="form_title">Clone แบบฟอร์ม</div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.InputMultiSelect
                {...field}
                options={options}
                placeholder={"กรุณาเลือกฟอร์มที่ต้องการ"}
                errors={errors.activity?.message}
              />
            )}
            name="activity"
            // defaultValue=""
          />
        </div>
        <div className="action_row">
          <div className="btn_wrap">
            <Buttons.BgStandard theme_gray label="Back" onClick={onCancel} />
          </div>
          <div className="btn_wrap">
            <Buttons.BgStandard type="submit" label="Submit" />
          </div>
        </div>
      </form>
    </ActivityDuplicateFormStyled>
  );
};

ActivityDuplicateForm.propTypes = {};

export default ActivityDuplicateForm;
